<template>
	<div class="container pt-5 pb-5">
		<div class="row">
			<div class="col-md-3" v-for="category in categories" :key="category['.key']"
           @click.prevent="to(category.slug)"
           style="padding: 5px">
				<div class="card-category d-flex justify-content-center align-items-center p-3">
					<h5 class="text-center"> {{ category.name }} </h5>
					<figure>
						<img :src="category.background" />
					</figure>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { categories } from '../../firebase'

	export default {
		data() {
			return {}
		},
		firestore() {
      return {
        categories: categories.orderBy('priority')
      }
    },
		methods: {
			to(slug) {
				this.$router.push({ name: 'category-admin', params: { slug } })
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/admin/Files.vue